import React, { memo } from "react";
import { SvgIcon } from "@mui/material";

interface WindowsDeviceIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const WindowsDeviceIcon: React.FC<WindowsDeviceIconProps> = ({
  className,
  width = 24,
  height = 24,
}) => {
  return (
    <SvgIcon className={className} style={{ width, height }} viewBox="0 0 156 183" fill="none">
      <path
        d="M123.5 127.719H32.5C29.4884 127.699 26.6051 126.287 24.4755 123.788C22.346 121.29 21.1421 117.908 21.125 114.375V38.125C21.1421 34.5922 22.346 31.2098 24.4755 28.7116C26.6051 26.2135 29.4884 24.8013 32.5 24.7812H123.5C126.511 24.8013 129.395 26.2135 131.524 28.7116C133.654 31.2098 134.858 34.5922 134.875 38.125V114.375C134.858 117.908 133.654 121.29 131.524 123.788C129.395 126.287 126.511 127.699 123.5 127.719ZM32.5 36.2187C32.069 36.2187 31.6557 36.4196 31.3509 36.7771C31.0462 37.1346 30.875 37.6195 30.875 38.125V114.375C30.875 114.881 31.0462 115.365 31.3509 115.723C31.6557 116.081 32.069 116.281 32.5 116.281H123.5C123.931 116.281 124.344 116.081 124.649 115.723C124.954 115.365 125.125 114.881 125.125 114.375V38.125C125.125 37.6195 124.954 37.1346 124.649 36.7771C124.344 36.4196 123.931 36.2187 123.5 36.2187H32.5Z"
        fill="currentColor"
      />
      <path
        d="M97.5 158.219H78C76.7123 158.199 75.4819 157.59 74.5712 156.522C73.6606 155.454 73.1419 154.011 73.125 152.5V122C73.125 120.483 73.6385 119.029 74.553 117.956C75.4669 116.884 76.7071 116.281 78 116.281C79.2929 116.281 80.5331 116.884 81.447 117.956C82.3615 119.029 82.875 120.483 82.875 122V146.781H97.5C98.7929 146.781 100.033 147.384 100.947 148.456C101.862 149.529 102.375 150.983 102.375 152.5C102.375 154.017 101.862 155.471 100.947 156.544C100.033 157.616 98.7929 158.219 97.5 158.219Z"
        fill="currentColor"
      />
      <path
        d="M78 158.219H58.5C57.2071 158.219 55.9671 157.616 55.0529 156.544C54.1386 155.471 53.625 154.017 53.625 152.5C53.625 150.983 54.1386 149.529 55.0529 148.456C55.9671 147.384 57.2071 146.781 58.5 146.781H78C79.2929 146.781 80.5331 147.384 81.447 148.456C82.3615 149.529 82.875 150.983 82.875 152.5C82.875 154.017 82.3615 155.471 81.447 156.544C80.5331 157.616 79.2929 158.219 78 158.219Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(WindowsDeviceIcon);
